var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGamelogo9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M7.757 1.33c-.85 0-1.655.169-2.416.506l-.313.156c-.865.44-1.554 1.056-2.067 1.845-.513.79-.769 1.653-.769 2.59H13.31c0-.937-.256-1.8-.769-2.59-.512-.79-1.198-1.404-2.055-1.845l-.312-.156c-.762-.337-1.567-.505-2.416-.505m0 1c.705 0 1.381.14 1.97.4l.3.15c.707.364 1.255.855 1.674 1.5.218.336.376.683.477 1.046H3.323c.101-.363.26-.71.477-1.045.42-.645.97-1.135 1.675-1.495l.27-.137c.63-.278 1.307-.42 2.012-.42",
    transform: "translate(-122 -304) translate(122 304)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4B34FB",
    d: "M6.152 4.282c-.092.093-.203.138-.33.138-.129 0-.237-.045-.325-.138-.088-.093-.132-.202-.132-.332 0-.127.044-.237.132-.33.088-.091.196-.138.324-.138s.24.046.331.138c.092.093.138.204.138.33 0 .13-.046.24-.138.332M10.005 4.282c-.088.093-.196.138-.324.138-.13 0-.24-.045-.331-.138-.093-.093-.138-.202-.138-.332 0-.127.045-.237.138-.33.092-.091.202-.138.33-.138.129 0 .237.046.325.138.088.093.132.204.132.33 0 .13-.044.24-.132.332M13.273 6.86H2.24v8.005c0 .369.128.68.385.937.256.256.568.385.937.385h8.4c.362 0 .67-.128.927-.385.256-.256.384-.568.384-.937V6.86zm-1 1v7.005c0 .117-.032.17-.091.23-.07.069-.124.092-.22.092h-8.4c-.117 0-.171-.033-.23-.092-.06-.06-.092-.113-.092-.23V7.86h9.033z",
    transform: "translate(-122 -304) translate(122 304)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#4B34FB",
    strokeLinecap: "round",
    d: "M.5 7.15L.5 13.706M15.012 7.15L15.012 13.706M9.876 15.783L9.876 19.489M5.676 15.783L5.676 19.489M4.397.5L5.144 1.877M11.07.5L10.323 1.877",
    transform: "translate(-122 -304) translate(122 304)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGamelogo9);
export default __webpack_public_path__ + "static/media/gamelogo9.bb72bb28a06b0ae6f36cefe828d89a44.svg";
export { ForwardRef as ReactComponent };